import DraggableItineraryWidget from './DraggableItineraryWidget';
import { ItineraryWidgetHotspot, generateItineraryWidgetArea } from './ItineraryWidgetHotspot';
import { WidgetBase } from '@go-shared/types/feedTemplate';
import { getWidgetHTML } from '@go-shared/lib/feed';
import { BaseFeedEditorHotspotProps, BaseDraggableSourceProps } from '@go-client/lib/feedEditor';

export const ItineraryWidget: WidgetBase<BaseFeedEditorHotspotProps, BaseDraggableSourceProps> = {
  hotspot: ItineraryWidgetHotspot,
  draggable: DraggableItineraryWidget,
  getHTML: getWidgetHTML,
  getArea: generateItineraryWidgetArea,
};
